function PopupClass(GM) {
  const Popup = function (position, content, map) {
    this.map_ = map;
    this.position = position;
    content.classList.add('popup-bubble-content');
    const pixelOffset = document.createElement('div');
    pixelOffset.classList.add('popup-bubble-anchor');
    pixelOffset.appendChild(content);
    this.anchor = document.createElement('div');
    this.opened = false;
    this.anchor.classList.add('popup-tip-anchor');
    this.anchor.appendChild(pixelOffset);
    this._listeners = [];
    this.stopEventPropagation();
    this._listeners.push(
      GM.event.addListener(this.map_, 'click', () => {
        !this.map || this.close();
      }),
    );
    this._listeners.push(
      GM.event.addListener(map, `zip-zap-opened`, other => {
        if (this !== other) {
          this.close();
        }
      }),
    );
  };
  Popup.prototype = Object.create(GM.OverlayView.prototype);
  Popup.prototype.onAdd = function () {
    this.opened = true;
    GM.event.trigger(this.map_, `zip-zap-opened`, this);
    this.getPanes().floatPane.appendChild(this.anchor);
    this.panMap();
  };
  Popup.prototype.clearListeners = function () {
    this._listeners.forEach(e => {
      GM.event.removeListener(e);
      e.listener = null;
    });
    this._listeners = this._listeners.filter(e => {
      return e != null;
    });
  };
  Popup.prototype.panMap = function () {
    const map = this.map_;
    const bounds = map.getBounds();
    if (!bounds) return;
    const { position } = this;
    if (bounds.contains(position)) {
      setTimeout(() => {
        const mapDiv = map.getDiv();
        const bounding = this.anchor.querySelector('.popup-content').getBoundingClientRect();
        let y = 0;
        let x = 0;
        if (bounding.top - bounding.height - 30 < 0) {
          y = bounding.top - bounding.height - 30;
        } else if (bounding.bottom > mapDiv.offsetHeight) {
          y = bounding.top - mapDiv.offsetHeight + 110;
        }
        if (bounding.left < 0) {
          x = bounding.left - 20;
        } else if (bounding.right > mapDiv.offsetWidth) {
          x = bounding.left - mapDiv.offsetWidth + bounding.width + 20;
        }
        if (x !== 0 || y !== 0) {
          map.panBy(x, y);
        }
      }, 0);
    } else {
      map.panTo(position);
    }
  };
  Popup.prototype.onRemove = function () {
    this.opened = false;
    if (this.anchor.parentElement) {
      this.anchor.parentElement.removeChild(this.anchor);
    }
  };
  Popup.prototype.draw = function () {
    const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
    const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none';

    if (display === 'block') {
      this.anchor.style.left = divPosition.x + 'px';
      this.anchor.style.top = divPosition.y + 'px';
    }
    if (this.anchor.style.display !== display) {
      this.anchor.style.display = display;
    }
  };
  Popup.prototype.destroy = function () {
    this.setMap(null);
    this.clearListeners();
  };
  Popup.prototype.stopEventPropagation = function () {
    const anchor = this.anchor;
    anchor.style.cursor = 'auto';
    [
      'click',
      'dblclick',
      'contextmenu',
      // 'wheel',
      'mousedown',
      // 'touchstart',
      'pointerdown',
    ].forEach(event => {
      this._listeners.push(
        GM.event.addDomListener(anchor, event, e => {
          if (e.stopPropagation) {
            e.stopPropagation();
          }
        }),
      );
    });
  };
  return Popup;
}
export default PopupClass;
